
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/stories/[category]/[handle]",
      function () {
        return require("private-next-pages/blogs/stories/[category]/[handle].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/stories/[category]/[handle]"])
      });
    }
  